import useStoreBaseActions from './useStoreBaseActions'

export default useStoreBaseActions
